/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useMemo } from "react";

export interface IPermissions {
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canRead?: boolean;
}

const usePermissions = (
  permissions: IPermissions,
  formType: "edit" | "create" = "create",
) => {
  const canCreate = permissions.canCreate;
  const canEdit = permissions.canEdit;
  const canDelete = permissions.canDelete && formType === "edit";
  const isCreating = formType === "create";
  const isEditing = formType === "edit";
  const isCreatable = permissions.canCreate && formType === "create";
  const isEditable = permissions.canEdit && formType === "edit";
  const isDisabled = !(isCreatable || isEditable);
  return useMemo(
    () => ({
      isDisabled,
      canCreate,
      canEdit,
      canDelete,
      isCreating,
      isEditing,
      isCreatable,
      isEditable,
    }),
    [permissions, formType],
  );
};

export default usePermissions;
